// removed by extract-text-webpack-plugin
module.exports = {"iFrame":"iframe__iFrame__1QFKd"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Iframe/iframe.css
// module id = 928
// module chunks = 2